import { render, staticRenderFns } from "./BudgetModal.vue?vue&type=template&id=a66bfe7a&scoped=true&"
import script from "./BudgetModal.vue?vue&type=script&lang=js&"
export * from "./BudgetModal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetModal.vue?vue&type=style&index=0&id=a66bfe7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66bfe7a",
  null
  
)

export default component.exports